import { Divider } from '@mantine/core';

import classes from './Divider.module.css';

const DividerDefaults = Divider.extend({
  classNames: {
    root: classes.root,
  },
});

export { Divider, DividerDefaults };
